import React from "react";
import type { GetStaticPropsContext, NextPage } from "next";

import { IProjectList } from "@components-pages/proyectos/ProjectList";
import { en, es } from "@lang";
import { CPagesPath } from "shared/models/const/pages-path";
import RealestateList from "@components-pages/proyectos/RealestateList";
import HeadMeta, { IHeadMetaComponent } from "@components/head-meta";
import { useRouter } from "next/dist/client/router";
import { CKeyWordsPages } from "shared/models/const/keywords.const";

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

const Proyectos: NextPage = (props: any) => {
  const router = useRouter();
  const filters: IProjectList = {
    filters: {
      typeProperty: [{ id: 14, name: "Proyecto", slug: "project" }],
    },
    refRequest: "project-list-query",
    detailPath: CPagesPath.es.project_Detail,
  };

  const metaData: IHeadMetaComponent = {
    description: "project",
    title: "projects",
    url: router.asPath,
    keyWords: CKeyWordsPages.project,
  };

  return (
    <>
      <HeadMeta {...metaData}></HeadMeta>
      <RealestateList defaultFilters={filters} />
    </>
  );
};

export default Proyectos;
